export default __webpack_public_path__ + "static/media/Summer-Schedule-BOTTOM-2026.ad51d56e.png";